<template>
  <section class="calculator-section">
    <p class="calculator-description">
      Explore our full suite of free online statistics calculators—ideal for coursework,
      research, or data analysis. Each statistics calculator is accurate, easy to use,
      and comes with clear, step-by-step explanations.
    </p>
    <div v-animation class="calculator-list" data-animation="fade-in-up">
      <LinkCard
        v-for="calculator in calculators"
        :key="calculator.title"
        :title="calculator.title"
        :description="calculator.description"
        :link="calculator.link"
      />
    </div>
  </section>
</template>

<script>
import LinkCard from './LinkCard';

export default {
  components: {
    LinkCard,
  },
  data() {
    return {
      calculators: [
        {
          title: 'Mean, Median, Mode Calculator',
          description: 'Quickly access the most essential summary statistics in just seconds. Whether you\'re analyzing test scores, survey results, or financial data, this descriptive statistics calculator lets you compute the key measures of central tendency.',
          link: '/mean-median-mode-calculator/',
        },
        {
          title: 'Standard Deviation Calculator ',
          description: 'This population and sample standard deviation calculator helps you analyze data dispersion around the mean. Efficiently compute standard deviation for both sample and population datasets to support a wide range of statistical needs.',
          link: '/standard-deviation-calculator/',
        },
        {
          title: 'Linear Regression Calculator',
          description: 'Perform simple linear regression analysis using the Ordinary Least Squares (OLS) method. This statistics calculator is valuable for students, analysts, and professionals seeking to understand data trends and make predictions.',
          link: '/linear-regression-calculator/',
        },
        {
          title: 'Kurtosis Calculator',
          description: 'Quickly evaluate the peakedness of a distribution with this free statistics calculator. It measures kurtosis to help identify the frequency of outliers in your data and supports both sample and population data.',
          link: '/kurtosis-calculator/',
        },
        {
          title: 'Skewness Calculator',
          description: 'Measure the asymmetry of your data distribution. This online statistics calculator determines whether your data is skewed to the left, right, or is symmetrical. It accommodates both sample and population data.',
          link: '/skewness-calculator/',
        },
        {
          title: 'Variance Calculator',
          description: 'Calculate the variance of a dataset to understand how data points are dispersed around the mean. This tool supports both sample and population variance—making it suitable for a wide range of statistical analyses.',
          link: '/variance-calculator/',
        },
        {
          title: 'Confidence Interval Calculator',
          description: 'Explore our full suite of free online statistics calculators—ideal for coursework, research, or data analysis. Each statistics calculator is accurate, easy to use, and comes with clear, step-by-step explanations.',
          link: '/confidence-interval-calculator/',
        },
        {
          title: 'Coefficient of Variation Calculator',
          description: 'Computes the coefficient of variation (CV)—a standardized measure of data dispersion relative to the mean. This unitless metric is handy for comparing variability across datasets with different units or scales.',
          link: '/coefficient-of-variation-calculator/',
        },
        {
          title: 'Difference in Means Calculator',
          description: 'Use this calculator to perform hypothesis testing when comparing the means of two groups. Use it as a t-test calculator when the population standard deviation is unknown and as a z-test calculator when it’s known.',
          link: '/difference-in-means-calculator/',
        },
        {
          title: 'Hypothesis Test Calculator',
          description: 'This statistics calculator computes the coefficient of variation (CV)—a standardized measure of data dispersion relative to the mean. This unitless metric is handy for comparing variability across datasets with different units or scales.',
          link: '/hypothesis-test-calculator/',
        },
        {
          title: 'P-Value Calculator',
          description: 'This stats calculator computes p-values for various statistical tests, including z-tests, t-tests, F-tests, and chi-square tests. It determines the statistical significance of test results by providing quick and accurate p-value calculations.',
          link: '/p-value-calculator/',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.calculator-section {
  .calculator-description {
    color: var(--main-dark-shade-2);
    text-align: center;
    font-size: 21px;
    line-height: 110%;
    margin-bottom: 30px;
  }

  .calculator-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;
  }
}

@include bp($bp-mobile) {
  .calculator-section {
    .calculator-description {
      text-align: start;
      font-size: 18px;
    }

    .calculator-list {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }
}
</style>
